import {
  DocumentDuplicateIcon,
  PencilIcon,
  TrashIcon,
} from "@heroicons/react/24/solid";
import React from "react";

interface ProjectDocumentDropdownMenu {
  closeMenu: () => void;
}

const ProjectDocumentDropdownMenu: React.FC<ProjectDocumentDropdownMenu> = ({
  closeMenu,
}) => {
  const actions = [
    {
      label: "Renommer le fichier",
      icon: <PencilIcon className="h-4 w-4 text-rajapiNavyBlue" />,
    },
    {
      label: "Fichier en double",
      icon: <DocumentDuplicateIcon className="h-4 w-4 text-rajapiNavyBlue" />,
    },
    {
      label: "Supprimer",
      icon: <TrashIcon className="h-4 w-4 text-rajapiNavyBlue" />,
    },
  ];

  return (
    <ul
      className="absolute right-0 mt-2 bg-white shadow-lg rounded-lg py-1 top-full z-20"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      {actions.map((action, index) => (
        <li
          key={index}
          className={` text-xs text-gray-700 hover:text-black cursor-pointer flex w-full gap-2 p-3 text-rajapiBlue ${
            index != actions.length - 1 && "border-b"
          }`}
          onClick={closeMenu}
        >
          {action.icon}
          <span className="w-auto text-nowrap">{action.label}</span>
        </li>
      ))}
    </ul>
  );
};

export default ProjectDocumentDropdownMenu;
